/**
 * ListItem.jsx - ListItem - Individual list item component
 * 
 * CHANGE HISTORY:
 * - 251018_1327 [43ebfec] danielbeer: refactor: restructure packages - extract all nested packages to top level
 */
import React, { useState } from 'react';
import { useOrganizr } from '../src/OrganizrContext';

const ListItem = ({ item, listId, depth = 0, onDragStart, onDragOver, onDrop }) => {
  const { updateItem, deleteItem, addItem } = useOrganizr();
  const [isEditing, setIsEditing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [editedName, setEditedName] = useState(item.name);
  
  const hasChildren = item.children && item.children.length > 0;
  
  const handleSave = () => {
    updateItem(listId, item.id, { name: editedName });
    setIsEditing(false);
  };
  
  const handleDelete = () => {
    if (hasChildren) {
      if (!window.confirm('This item has children. Delete anyway?')) return;
    }
    deleteItem(listId, item.id);
  };
  
  const handleAddChild = () => {
    addItem(listId, {
      name: 'New Child',
      color: item.color
    }, item.id);
    setIsExpanded(true);
  };
  
  return (
    <div className="list-item-container" style={{ marginLeft: depth * 24 }}>
      <div
        className="list-item"
        draggable
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        {hasChildren && (
          <button
            className="list-item-expand"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? '▼' : '▶'}
          </button>
        )}
        
        <span className="list-item-icon" style={{ color: item.color }}>
          {item.icon || '•'}
        </span>
        
        {isEditing ? (
          <input
            type="text"
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
            onBlur={handleSave}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave();
              if (e.key === 'Escape') {
                setEditedName(item.name);
                setIsEditing(false);
              }
            }}
            className="list-item-input"
            autoFocus
          />
        ) : (
          <span
            className="list-item-name"
            onDoubleClick={() => setIsEditing(true)}
          >
            {item.name}
          </span>
        )}
        
        <div className="list-item-actions">
          <input
            type="color"
            value={item.color}
            onChange={(e) => updateItem(listId, item.id, { color: e.target.value })}
            className="list-item-color"
            title="Change color"
          />
          <button
            className="list-item-add-child"
            onClick={handleAddChild}
            title="Add child"
          >
            +
          </button>
          <button
            className="list-item-delete"
            onClick={handleDelete}
            title="Delete"
          >
            ×
          </button>
        </div>
      </div>
      
      {hasChildren && isExpanded && (
        <div className="list-item-children">
          {item.children.map(child => (
            <ListItem
              key={child.id}
              item={child}
              listId={listId}
              depth={depth + 1}
              onDragStart={onDragStart}
              onDragOver={onDragOver}
              onDrop={onDrop}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ListItem;
